// removed by extract-text-webpack-plugin
module.exports = {"termDefinition":"termDefinition--2XkZX"};